/**
 * Polyfill for String.prototype.replaceAll
 * Replaces all occurrences of a search value with a replacement
 */
if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function (
    searchValue: string | RegExp,
    replaceValue: string | ((substring: string, ...args: any[]) => string),
  ): string {
    // If searchValue is a RegExp
    if (searchValue instanceof RegExp) {
      // RegExp must have global flag for replaceAll
      if (!searchValue.global) {
        throw new TypeError('String.prototype.replaceAll called with a non-global RegExp argument');
      }
      // Use the native replace with global RegExp
      return this.replace(searchValue, replaceValue as any);
    }

    // If searchValue is a string or needs to be coerced to one
    const searchString = String(searchValue);

    // Escape special regex characters in search string
    // This also handles empty searchString correctly by resulting in an empty regex with 'g' flag
    const escapedSearch = searchString.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(escapedSearch, 'g');

    // Use native replace with the constructed global RegExp
    return this.replace(regex, replaceValue as any);
  };
}
